import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Headline, Text } from '@lichtblick/ui-components';
import { RichText } from '../../../../helpers/RichText';
import { AButton } from '../../../AButton';
import { AImage } from '../../../AImage';
import { StyledIcon, StyledItem } from '../../../AListItem/AListItem.styles';
import { StyledMList } from '../../../MList';
import { ImageWrapper, MProductItemListRoot, ProductItemList, ProductListItem } from './MProductItemList.styles';
import { ProductInformation } from './shared';
const elementMappers = {
    ul: ({ children })=>/*#__PURE__*/ _jsx(StyledMList, {
            children: children
        }),
    li: ({ children })=>/*#__PURE__*/ _jsxs(StyledItem, {
            children: [
                /*#__PURE__*/ _jsx(StyledIcon, {
                    $color: "light-moss"
                }),
                children
            ]
        })
};
export const MProductItemList = ({ backgroundColor, cta, items })=>{
    const itemIsDefined = (item)=>Boolean(item);
    const sanitizedItems = items.filter(itemIsDefined);
    const numItems = sanitizedItems.length < 2 ? 2 : sanitizedItems.length;
    return /*#__PURE__*/ _jsxs(MProductItemListRoot, {
        $backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ _jsx(ProductItemList, {
                $numItems: numItems,
                children: sanitizedItems.map(({ image, sellingPoints, subtitle, textCTA, title })=>/*#__PURE__*/ _jsxs(ProductListItem, {
                        children: [
                            image?.[0] && /*#__PURE__*/ _jsx(ImageWrapper, {
                                children: /*#__PURE__*/ _jsx(AImage, {
                                    ...image[0]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(ProductInformation, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        size: "Xs",
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ _jsx(Headline, {
                                        renderAs: "h3",
                                        size: "S",
                                        children: title
                                    }),
                                    sellingPoints && /*#__PURE__*/ _jsx(RichText, {
                                        elementMappers: elementMappers,
                                        richText: sellingPoints
                                    })
                                ]
                            }),
                            textCTA?.[0] && /*#__PURE__*/ _jsx(AButton, {
                                ...textCTA[0],
                                variant: "link"
                            })
                        ]
                    }, title))
            }),
            /*#__PURE__*/ _jsx("div", {
                children: cta?.length === 1 && /*#__PURE__*/ _jsx(AButton, {
                    ...cta[0]
                })
            })
        ]
    });
};

//# sourceMappingURL=MProductItemList.js.map